import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGetJobsFacetsQuery } from '@job-facets/redux/fetchApiSlice';
import CheckBoxGroup from '@core/react/shared-component/CheckBoxGroup/View';
import whenCheckBoxChanged, {
	optionSearchLogic,
	openAccordionToggle,
} from '@job-facets/components/facets/Service';
import SingleAccordion from '@core/react/shared-component/Accordion/SingleAccordion';
import ResetFormModule from '@job-facets/components/reset-form/Module';

import { __ } from '@wordpress/i18n';

function FacetsModule() {
	const { data } = useGetJobsFacetsQuery();
	const dispatch = useDispatch();

	// eslint-disable-next-line camelcase
	const {
		job_listing_type,
		job_listing_category,
		job_listing_industry,
		job_listing_company_size,
		is_remote_position,
	} = useSelector((state) => state.jobsFormInput);

	const mergedDefaultData = {
		// eslint-disable-next-line camelcase
		job_listing_type,
		// eslint-disable-next-line camelcase
		job_listing_category,
		job_listing_industry,
		job_listing_company_size,
		is_remote_position,
	};

	if (!data) return <div className='header-hero__skeleton w-100 vh-100'><ResetFormModule /></div>;
	
	const {
		facets: {
			jobListingType,
			jobListingCategory,
			jobListingIndustry,
			jobListingCompanySize,
			isRemotePosition,
		},
	} = data;

	const facetsArray = [
		jobListingType,
		jobListingCategory,
		jobListingIndustry,
		jobListingCompanySize,
		isRemotePosition,
	];

	const facetsJsx = facetsArray?.map(({ options, slug, label }) => {
		if (options.length > 0) {
			return (
				<div className='checkboxgroup__separator' key={slug}>
					<SingleAccordion
						key={label}
						header={label}
						openAccordionToggle={openAccordionToggle(slug, mergedDefaultData)}
						content={
							<CheckBoxGroup
								eventCheckBoxChange={(e) =>
									whenCheckBoxChanged(e, dispatch, slug)
								}
								enableSearch={optionSearchLogic(slug)}
								options={options}
								checkBoxProps={{
									checkedOptions: mergedDefaultData[slug],
									parentNodeClassNames: 'checkboxgroup__item',
									inputFieldClassNames:
										'checkboxgroup__input-check ss-custom-checkbox ss-custom-checkbox--small',
									labelClassNames: 'checkboxgroup__input-check-label',
								}}
								groupListClassNames='checkboxgroup__lists'
								placeholder={__('Search', 'job')} // placeholder for the input search text field
								className='checkboxgroup__search' // classname for the search text field
							/>
						}
					/>
				</div>
			);
		}
	});

	return (
		<>
			<ResetFormModule />
			{facetsJsx}
		</>
	);
}

export default FacetsModule;
